import React from 'react';
import Footer from '../../components/Footer/Footer';
import Navbar from '../../components/Navbar/Navbar';
import { Phone, Mail, MessageCircle } from 'lucide-react';

export default function ContactPage() {
  const phone = '+56 9 8271 9948';
  const phoneHref = 'tel:+56982719948';
  const email = 'commitflow.cf@gmail.com';
  const emailHref = 'mailto:commitflow.cf@gmail.com';
  const whatsappHref = 'https://wa.me/56982719948';

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      {/* Hero */}
      <section className="pt-40 pb-16 bg-gradient-to-b from-slate-50 to-white">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-white rounded-full border border-slate-200 shadow-sm mb-8">
            <span className="h-2 w-2 rounded-full bg-orange-500"></span>
            <span className="text-sm text-slate-600">Estamos aquí para ayudarte</span>
          </div>
          
          <h1 className="text-4xl sm:text-5xl font-semibold text-slate-900 tracking-tight mb-6">
            Contacta con
            <br />
            <span className="text-slate-400">nuestro equipo</span>
          </h1>
          
          <p className="text-lg text-slate-500 max-w-xl mx-auto">
            ¿Tienes preguntas? Escríbenos y te responderemos lo antes posible.
          </p>
        </div>
      </section>

      {/* Contact cards */}
      <section className="pb-20 bg-white">
        <div className="max-w-2xl mx-auto px-6">
          <div className="space-y-4">
            {/* Teléfono */}
            <div className="bg-slate-50 rounded-xl p-6 border border-slate-200 flex flex-col sm:flex-row sm:items-center gap-4">
              <div className="flex items-center gap-4 flex-1">
                <div className="w-12 h-12 rounded-xl bg-slate-900 flex items-center justify-center">
                  <Phone className="w-5 h-5 text-white" />
                </div>
                <div>
                  <div className="text-sm text-slate-500">Teléfono</div>
                  <div className="text-slate-900 font-semibold">{phone}</div>
                </div>
              </div>
              <div className="flex gap-2">
                <a 
                  href={phoneHref} 
                  className="px-4 py-2 bg-slate-900 text-white text-sm font-medium rounded-lg hover:bg-slate-800 transition-colors"
                >
                  Llamar
                </a>
                <a 
                  href={whatsappHref} 
                  target="_blank" 
                  rel="noreferrer" 
                  className="px-4 py-2 bg-emerald-600 text-white text-sm font-medium rounded-lg hover:bg-emerald-700 transition-colors"
                >
                  WhatsApp
                </a>
              </div>
            </div>

            {/* Email */}
            <div className="bg-slate-50 rounded-xl p-6 border border-slate-200 flex flex-col sm:flex-row sm:items-center gap-4">
              <div className="flex items-center gap-4 flex-1">
                <div className="w-12 h-12 rounded-xl bg-slate-900 flex items-center justify-center">
                  <Mail className="w-5 h-5 text-white" />
                </div>
                <div>
                  <div className="text-sm text-slate-500">Correo electrónico</div>
                  <div className="text-slate-900 font-semibold text-sm sm:text-base">{email}</div>
                </div>
              </div>
              <a 
                href={emailHref} 
                className="px-4 py-2 bg-slate-900 text-white text-sm font-medium rounded-lg hover:bg-slate-800 transition-colors"
              >
                Enviar correo
              </a>
            </div>

            {/* Horario */}
            <div className="bg-slate-50 rounded-xl p-6 border border-slate-200 flex items-center gap-4">
              <div className="w-12 h-12 rounded-xl bg-slate-900 flex items-center justify-center">
                <MessageCircle className="w-5 h-5 text-white" />
              </div>
              <div>
                <div className="text-sm text-slate-500">Horario de atención</div>
                <div className="text-slate-900 font-semibold">Lunes a Viernes · 9:00 - 18:00</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-16 bg-slate-900">
        <div className="max-w-3xl mx-auto px-6 text-center">
          <h2 className="text-2xl font-semibold text-white mb-4">
            ¿Listo para organizar tus proyectos?
          </h2>
          <p className="text-slate-400 mb-6">
            Prueba CommitFlow y mejora la gestión de tu equipo
          </p>
          <a 
            href="/login" 
            className="inline-flex px-6 py-3 bg-white text-slate-900 text-sm font-medium rounded-full hover:bg-slate-100 transition-colors"
          >
            Comenzar ahora
          </a>
        </div>
      </section>

      <Footer />
    </div>
  );
}